function shouldDisplayPopupToday() {
  var lastPopupDate = localStorage.getItem("lastPopupDate");
  if (!lastPopupDate) return true;

  var currentDate = new Date();
  var lastDate = new Date(lastPopupDate);

  return currentDate.toDateString() !== lastDate.toDateString();
}


function newsletterPopup() {
  let newsletter = document.getElementById("NewsletterPopup");

  if (!newsletter) return;

  let modalInstance = new theme.Modals(newsletter.id, "");

  setTimeout(() => {
    if (shouldDisplayPopupToday()) {
      modalInstance.open();
      localStorage.setItem("lastPopupDate", new Date().toString());
    }
  }, 3000);
}


function showMenuOnHover() {
  let items = document.querySelectorAll('.header__inline-menu summary.header__menu-item ');

  if(!items) return;

  items.forEach(item => {
    let hasMouseOverOccurred = false;
    let parentDetails = item.parentElement;
    item.addEventListener('mouseover', function () {
      if (!hasMouseOverOccurred) {
        this.parentElement.setAttribute('open','')
      }
    });

    parentDetails.addEventListener('mouseleave', function () {
      hasMouseOverOccurred = false;
      this.removeAttribute('open');
    });
  });
}

function videoAutoplay() {
  document.body.addEventListener('click', function () {
    let videos = document.querySelectorAll('.shop-luxery-lazy video');
  
    if(!videos) return;
    videos.forEach(video => {
      if (!video.paused) {
          video.play();
      } 
    });
  });
  
  document.body.addEventListener('touchstart', function () {
    let videos = document.querySelectorAll('.shop-luxery-lazy video');
  
    if(!videos) return;
    videos.forEach(video => {
      if (!video.paused) {
          video.play();
      } 
    });
  });
}



document.addEventListener("DOMContentLoaded", function () {
  newsletterPopup();
  if(!theme.config.bpSmall) { showMenuOnHover(); }
  videoAutoplay();
});
